function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnSocialNewsletter = function SvgBtnSocialNewsletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M25 50h25V25c0 13.807-11.193 25-25 25zM0 25v25h25C11.193 50 0 38.807 0 25zM25 0H0v25C0 11.193 11.193 0 25 0zM25 0c13.807 0 25 11.193 25 25V0H25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zM12.892 15.415h24.957c.076 0 .135.035.208.044L25.192 28.324 12.383 15.516c.168-.041.331-.101.509-.101zm27.034 18.719c0 1.151-.932 2.08-2.08 2.08H12.892a2.079 2.079 0 0 1-2.08-2.08V17.495c0-.179.062-.338.103-.506l13.542 13.539a1.04 1.04 0 0 0 1.468 0L39.763 16.69c.103.246.163.52.163.804v16.64z"
  }));
};
export default SvgBtnSocialNewsletter;